export default "__VITE_ASSET__LvnZdNrF__"